import { queryClientBigLogosView } from 'remote-com-shared/components/ClientLogos/services';
import { getForm } from 'remote-com-shared/domains/hubspot/services';

import { getSlicesContext } from '@/src/domains/prismic/helpers';
import { querySharedServices } from '@/src/domains/shared/services';
import { queryGlobalRecruitingEmployment } from '@/src/views/Services/GlobalRecruitingEmployment/services';

export { GlobalRecruitingEmployment as default } from '@/src/views/Services/GlobalRecruitingEmployment';

export async function getStaticProps({ preview = false, previewData = {}, locale }) {
  const dataContent = await queryGlobalRecruitingEmployment({ previewData, locale });
  const sharedServices = await querySharedServices({ previewData, locale });
  if (!dataContent) {
    return {
      notFound: true,
    };
  }
  const clientLogosView = await queryClientBigLogosView({ previewData, locale });
  const heroData = dataContent.body.find(({ slice_type: type }) => type === 'hero_section');
  const {
    hubspot_form_id: formId,
    hero_form_title: formTitle,
    hero_form_description: formDescription,
    hero_form_button_label: formButtonLabel,
  } = heroData.primary;

  const { data: hubspotFormDefinition } = await getForm(formId);

  const body = await getSlicesContext(dataContent.body, {
    hero_section: async () => ({
      hubspotFormDefinition,
      formTitle,
      formDescription,
      formButtonLabel,
    }),
    special_offer: async () => ({
      hubspotFormDefinition,
      formTitle,
      formDescription,
      formButtonLabel,
    }),
    partners_logos_section: async () => ({
      clientLogosView,
    }),
  });

  return {
    props: {
      ...dataContent,
      preview,
      sharedServices,
      body,
    },
  };
}
